(() => {
  if (customElements.get('lumevoke-space-finder')) return;

  class LumevokeSpaceFinder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.spaceFinderReady === 'true') return;

      this.dataset.spaceFinderReady = 'true';
      this.abortController = new AbortController();

      this.querySelectorAll('quick-buy-modal').forEach((modal) => {
        modal.addEventListener('dialog:before-show', () => this.injectSummary(modal), {
          signal: this.abortController.signal
        });
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      delete this.dataset.spaceFinderReady;
    }

    injectSummary(modal) {
      const summaryTemplate = this.querySelector(`template[data-space-finder-summary="${CSS.escape(modal.id)}"]`);
      const productInfo = modal.querySelector('.product-info__block-list');

      if (!summaryTemplate || !productInfo || productInfo.querySelector('[data-space-finder-injected]')) return;

      const summary = summaryTemplate.content.firstElementChild.cloneNode(true);
      summary.dataset.spaceFinderInjected = 'true';

      const insertionPoint = productInfo.querySelector(
        '[data-block-type="variant-picker"], [data-block-type="quantity-selector"], [data-block-type="buy-buttons"]'
      );

      productInfo.insertBefore(summary, insertionPoint || null);
    }
  }

  customElements.define('lumevoke-space-finder', LumevokeSpaceFinder);
})();
